import React from 'react';
import  { YoutubeFilled, ArrowRightOutlined, PlaySquareFilled } from '@ant-design/icons'
import { Link } from 'react-router-dom';
import config from '../../config.json';
import HeroVisual from './HeroVisual';
import { Calculator } from '../pricing/PricingPage';
import CheckoutImage from '../../assets/hero-section.png';
import SecurityImage from '../../assets/privacy.png';
import PhoneInHand from '../../assets/phone-in-hand.png';
import AndroidBadge from '../../assets/android.svg';
import IOSBadge from '../../assets/ios.svg';
import WayaBankLogo from '../../assets/wayaBank.png';
import WayaGramLogo from '../../assets/wayagram.png';
import '../features/features.css';
import './home.css';

const REGISTER_URL = `${config.CUSTOMER_WEBSITE_URL}/register`;

const FACTS = [
    ['1.5%', 'per transaction, capped at ₦2,000'],
    ['5', 'ways for customers to pay'],
    ['Instant', 'settlement into WayaBank'],
    ['Free', 'Test mode to try everything'],
];

const STEPS = [
    ['Create an account', 'Sign up in minutes and try every feature in Test mode with test money.'],
    ['Verify your business', 'Complete your KYC online. Live mode unlocks as soon as you’re approved.'],
    ['Start getting paid', 'Share a payment link, send an invoice or connect your website or app.'],
];

const METHODS = ['Bank transfer', 'Card', 'USSD', 'PayAttitude', 'Dynamic virtual account'];

const ECOSYSTEM = [
    { name: 'WayaBank', logo: WayaBankLogo, url: process.env.REACT_APP_WAYABANK_URL },
    { name: 'WayaGram', logo: WayaGramLogo, url: process.env.REACT_APP_WAYAGRAM_URL },
];

function Home() {
    return (
        <main className="wqf wqh">
            <section className="wqh-hero" aria-labelledby="wqh-title">
                <div className="wqf-wrap wqh-hero-grid">
                    <div className="wqh-hero-copy">
                        {/* <h1 id="wqh-title" className="wqh-h1">
                            Get paid by anyone, anywhere
                        </h1> */}
                        {/* <p className="wqh-hero-sub">
                            Share a payment link, send an invoice or add checkout to your website. Customers pay by
                            transfer, card, USSD or PayAttitude, and you get settled fast.
                        </p> */}
                        <h1 id="wqh-title" className="wqh-h1 hero-title font-semibold leading-tight text-gray-600">Start accepting payments in <span className='text-green-500'><PlaySquareFilled style={{ fontSize: '35px', color: '#c2410c' }} />minutes</span></h1>
                        <p className="wqh-hero-sub">
                        One platform that lets you sell wherever your customers are — online, in‑person, anywhere in the world
                        </p>
                        <div className="wqf-ctas">
                            <a href={REGISTER_URL} className="wqf-btn wqf-btn-primary wqh-btn-lg">
                                Create an account
                            </a>
                            <Link to="/features" className="wqf-btn wqf-btn-ghost wqh-btn-lg">
                                See what you can do
                            </Link>
                        </div>
                    </div>
                    <HeroVisual />
                </div>

                <div className="wqf-wrap">
                    <ul className="wqh-facts">
                        {FACTS.map(([big, small]) => (
                            <li key={small}>
                                <strong>{big}</strong>
                                <span>{small}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            {/* What you can do: one look, each tile goes deeper on the Features page */}
            <section className="wqh-section" aria-labelledby="wqh-what">
                <div className="wqf-wrap">
                    <h2 id="wqh-what" className="wqf-h2">
                        One account for every way you get paid
                    </h2>
                    <div className="wqh-bento">
                        <Link to="/features#get-paid" className="wqh-tile wqh-tile-wide">
                            <h3 className="wqf-h3">No website? No problem.</h3>
                            <p className="wqf-body">
                                Create a payment link or an invoice and share it on WhatsApp, SMS or email. Bill
                                regular customers automatically with subscriptions.
                            </p>
                            <div className="wqh-stack" aria-hidden="true">
                                <div className="wqh-linkcard">
                                    <span className="wqh-linkcard-text">Payment link · ₦25,000</span>
                                    <span className="wqh-linkcard-btn">Share</span>
                                </div>
                                <div className="wqh-linkcard">
                                    <span className="wqh-linkcard-text">Invoice · ₦48,500</span>
                                    <span className="wqh-status">Paid</span>
                                </div>
                                <div className="wqh-linkcard">
                                    <span className="wqh-linkcard-text">Monthly plan · ₦10,000</span>
                                    <span className="wqh-status">Active</span>
                                </div>
                            </div>
                            <span className="wqh-more">Ways to get paid</span>
                        </Link>

                        <Link to="/features#checkout" className="wqh-tile">
                            <h3 className="wqf-h3">Five ways to pay</h3>
                            <ul className="wqh-chips">
                                {METHODS.map((m) => (
                                    <li key={m}>{m}</li>
                                ))}
                            </ul>
                            <img
                                src={CheckoutImage}
                                alt=""
                                className="wqh-tile-img"
                                loading="lazy"
                                decoding="async"
                            />
                            <span className="wqh-more">About checkout</span>
                        </Link>

                        <Link to="/features#money-out" className="wqh-tile">
                            <h3 className="wqf-h3">Your money, fast</h3>
                            <p className="wqf-body">
                                Instant settlement into WayaBank, or daily (T+1) or weekly into any bank. Pay suppliers
                                and staff from the same dashboard.
                            </p>
                            <div className="wqh-segment" aria-hidden="true">
                                <span className="is-on">Instant</span>
                                <span>Daily (T+1)</span>
                                <span>Weekly</span>
                            </div>
                            <span className="wqh-more">Settlement and payouts</span>
                        </Link>

                        <Link to="/features#security" className="wqh-tile">
                            <h3 className="wqf-h3">Secure by design</h3>
                            <p className="wqf-body">
                                Verified businesses, two-factor sign-in, a transaction PIN and OTP on payouts.
                            </p>
                            <img
                                src={SecurityImage}
                                alt=""
                                className="wqh-tile-img"
                                loading="lazy"
                                decoding="async"
                            />
                            <span className="wqh-more">How we keep you safe</span>
                        </Link>

                        <Link to="/get-started" className="wqh-tile wqh-tile-dark">
                            <h3 className="wqf-h3">Built for developers too</h3>
                            <p className="wqf-body">
                                WooCommerce plugin, SDKs for web and mobile, and a clean API with webhooks.
                            </p>
                            <code className="wqh-code">WAYASECK_TEST_…</code>
                            <span className="wqh-more">Read the docs</span>
                        </Link>
                    </div>
                </div>
            </section>

            {/* Live in three steps — a real sequence, so it's numbered */}
            <section className="wqh-section wqh-steps-section" aria-labelledby="wqh-steps">
                <div className="wqf-wrap">
                    <h2 id="wqh-steps" className="wqf-h2">
                        Live in three steps
                    </h2>
                    <ol className="wqh-steps">
                        {STEPS.map(([title, body]) => (
                            <li key={title}>
                                <h3 className="wqf-h4">{title}</h3>
                                <p className="wqf-small">{body}</p>
                            </li>
                        ))}
                    </ol>
                </div>
            </section>

            {/* Pricing you can try */}
            <section className="wqh-section" aria-labelledby="wqh-price">
                <div className="wqf-wrap wqh-price">
                    <div>
                        <h2 id="wqh-price" className="wqf-h2">
                            One rate. No surprises.
                        </h2>
                        <p className="wqf-lead">
                            1.5% per transaction, capped at ₦2,000, whichever way your customer pays. Try an amount
                            to see what you’d receive.
                        </p>
                        <Link to="/pricing" className="wqf-link">
                            See full pricing
                        </Link>
                    </div>
                    <div className="wqh-calc-wrap">
                        <Calculator />
                    </div>
                </div>
            </section>

            {/* App */}
            <section className="bg-primary-theme wqh-app" aria-labelledby="wqh-app">
                <div className="wqf-wrap wqh-app-grid">
                    <img
                        src={PhoneInHand}
                        alt="The WayaQuick app on a phone"
                        className="wqh-app-img"
                        loading="lazy"
                        decoding="async"
                    />
                    <div>
                        <h2 id="wqh-app" className="wqf-h2 wqh-app-title">
                            Your payments, in your pocket
                        </h2>
                        <p className="wqh-app-sub">Get the WayaQuick app and keep an eye on your business wherever you are.</p>
                        <div className="wqh-stores">
                            <a
                                href="https://play.google.com/store/apps/details?id=wayaquick.android"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={AndroidBadge} alt="Get it on Google Play" loading="lazy" />
                            </a>
                            <a
                                href="https://apps.apple.com/ng/app/wayaquick/id1658553550"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={IOSBadge} alt="Download on the App Store" loading="lazy" />
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Close */}
            <section className="wqh-final" aria-labelledby="wqh-final">
                <div className="wqf-wrap">
                    <h2 id="wqh-final" className="wqh-final-title">
                        Ready when you are
                    </h2>
                    <p className="wqf-lead wqh-final-sub">
                        Create an account and try everything in Test mode. No real money needed.
                    </p>
                    <div className="wqf-ctas wqh-final-ctas">
                        <a href={REGISTER_URL} className="wqf-btn wqf-btn-primary wqh-btn-lg">
                            Create an account
                        </a>
                        <Link to="/contact" className="wqf-btn wqf-btn-ghost wqh-btn-lg">
                            Talk to us
                        </Link>
                    </div>

                    <div className="wqh-eco">
                        <p className="wqf-small">More from WayaLinks</p>
                        <ul>
                            {ECOSYSTEM.map((e) => (
                                <li key={e.name}>
                                    <a href={e.url} target="_blank" rel="noopener noreferrer" aria-label={e.name}>
                                        <img src={e.logo} alt={e.name} loading="lazy" decoding="async" />
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Home;
